// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header___L8R2","box":"WorkspacesBox_box__YjQl9","node":"WorkspacesBox_node__2REHx"};